var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_67_4421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3662 12.8294C23.5032 10.7445 26.4968 10.7445 27.6338 12.8294L29.6141 16.4605C30.0456 17.2517 30.8099 17.807 31.6957 17.9729L35.7611 18.7342C38.0952 19.1713 39.0203 22.0183 37.3889 23.7439L34.5474 26.7494C33.9282 27.4043 33.6363 28.3028 33.7523 29.1965L34.2845 33.2982C34.5901 35.6531 32.1682 37.4127 30.023 36.3944L26.2865 34.6207C25.4724 34.2342 24.5276 34.2342 23.7135 34.6207L19.9771 36.3944C17.8318 37.4127 15.4099 35.6531 15.7155 33.2982L16.2477 29.1965C16.3637 28.3028 16.0718 27.4043 15.4526 26.7494L12.6111 23.7439C10.9797 22.0183 11.9048 19.1713 14.2389 18.7342L18.3043 17.9729C19.1901 17.807 19.9544 17.2517 20.3859 16.4605L22.3662 12.8294Z",
    fill: "#FAB908"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1911 15.2635L20.3859 16.4605L18.1911 15.2635C18.1192 15.3954 17.9918 15.4879 17.8441 15.5156L13.7788 16.2769C9.4995 17.0783 7.80355 22.2979 10.7945 25.4614L13.636 28.4669L15.3876 26.8109L13.636 28.4669C13.7392 28.5761 13.7878 28.7258 13.7685 28.8748L13.2363 32.9765C12.6761 37.2939 17.1161 40.5198 21.0491 38.6528L24.7856 36.8791C24.9213 36.8147 25.0787 36.8147 25.2144 36.8791L28.9509 38.6528C32.8839 40.5198 37.3239 37.2939 36.7637 32.9765L36.2315 28.8748C36.2122 28.7258 36.2608 28.5761 36.364 28.4669L39.2055 25.4614C42.1964 22.2979 40.5005 17.0783 36.2213 16.2769L32.1559 15.5156C32.0082 15.488 31.8808 15.3954 31.8089 15.2635L29.8286 11.6324C27.7441 7.8102 22.2559 7.8102 20.1714 11.6324L18.1911 15.2635Z",
    stroke: "white",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_67_4421",
    x: 0.78418,
    y: 0.265625,
    width: 48.4316,
    height: 47.4326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_67_4421"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_67_4421",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star_1.69a52ec01105c704cb3d8850bfa8ac10.svg";
export { ForwardRef as ReactComponent };